// umlaut-check: skip — "zuruecksetzen" ist der technische Name aus
// useGemerkteFilter.jsx, bleibt ASCII.
import React, {useState} from 'react';
import InertiaTable from 'laravel-inertia-react-table';
import {router, usePage} from '@inertiajs/react';
import ImportPositionsModal from './ImportPositionsModal.jsx';
import {Button, useEnhancedTranslation} from "laravel-inertia-backend";
import {PiMicrosoftExcelLogo} from "react-icons/pi";
import Icon from "@mdi/react";
import {mdiClipboardEditOutline} from "@mdi/js";
import {WeclappIcon} from "../../Icons/WeclappIcon.js";
import CurrencyTableCell from "../../Components/CurrencyTableCell.jsx";
import TimestampTableCell from "../../Components/TimestampTableCell.jsx";
import HelpTooltip from "../../Components/HelpTooltip.jsx";
import {AlleFilterZuruecksetzenLink, useGemerkteServerFilter} from "../../Components/Filter/useGemerkteFilter.jsx";

export default function Shipments(){
  const { shipments, weclappBaseUrl, col_definitions, can_order_editor, auth } = usePage().props;
  const [showModal,setShowModal] = useState(false);
  const [selectedDocumentId, setSelectedDocumentId] = useState(null);
  const {t} = useEnhancedTranslation();
  const {weichtAb, zuruecksetzen} = useGemerkteServerFilter("weclapp.shipments", {benutzerId: auth?.id});

  const openImportFor = (id) => {
    setSelectedDocumentId(id);
    setShowModal(true);
  }

    const openWeclappOrder = (id) => {
        window.open(`${weclappBaseUrl}app/shipment/${id}`, '_blank');
    }

  // Zweiter Einstieg in den Auftrags-Editor (PLAN.md 3.1, F2). Der Editor
  // hängt an der Auftrags-ID, nicht an der Lieferung: Die Liste zeigt auch
  // Umlagerungen ohne Auftragsbezug — dort gibt es nichts zu öffnen, deshalb
  // steht die Aktion nur an Zeilen mit `salesOrderId`.
  const openOrderEditor = (row) => {
    router.visit(
      `/order-editor/weclapp/${row.salesOrderId}`
      + `?type=shipment&number=${encodeURIComponent(row.shipmentNumber || '')}`,
    );
  }

  // Die Sichtbarkeit kommt serverseitig berechnet als Flag und nicht über
  // <Can>: Die Inertia-Middleware gibt dem Superadmin pauschal alle
  // Berechtigungsnamen mit, auch die, die er serverseitig nicht hat.
  // Die Aktionen sind eine Funktion, weil die letzte Zeile für Zeile
  // entschieden wird.
  const rowActions = (row) => ([
    { icon: <PiMicrosoftExcelLogo />, alt: t('import from File'), callback: (data) => openImportFor(data.id) },
    { icon: <WeclappIcon />, alt: t('open in Weclapp'), callback: (data) => openWeclappOrder(data.id) },
    ...(can_order_editor && row && row.salesOrderId
      ? [{
          icon: <Icon path={mdiClipboardEditOutline} size={1}/>,
          alt: 'Im Auftrags-Editor öffnen',
          callback: (data) => openOrderEditor(data),
        }]
      : []),
  ]);

  return (
    <>
      <InertiaTable
        key={'shipments-table'}
        data={shipments}
        title={
          <span className="d-inline-flex align-items-center gap-2">
            Verkauf - Lieferungen
            <HelpTooltip placement="right" size={0.95}>
              <div className="text-start">
                <strong>Welche Belege werden hier angezeigt?</strong>
                <div className="mt-1">Lieferungen aus Weclapp nach festen Regeln:</div>
                <ul className="mb-0 ps-3 mt-1">
                  <li>Belegtyp: <strong>Lieferung</strong> (Shipment) – alle Lieferarten (intern und normal)</li>
                  <li>Status: <strong>NEW</strong> – „wird erfasst", noch nicht abgeschlossen</li>
                </ul>
                <div className="mt-1">Sortierung: Liefernummer absteigend.</div>
              </div>
            </HelpTooltip>
          </span>
        }
        colDefinitions={[...col_definitions]}
        actionsDisplay={'column'}
        actions={rowActions}
        customCellRendererMap={{
        'orderDate': TimestampTableCell,
        'createdDate':TimestampTableCell
    }}
        customToolbarButtons={<AlleFilterZuruecksetzenLink sichtbar={weichtAb} onClick={zuruecksetzen} />}
      />
      <ImportPositionsModal show={showModal} documentId={selectedDocumentId} documentType={'shipments'} onClose={()=>setShowModal(false)} />
    </>
  );
}
